import './MiniPreloader.css';

function MiniPreloader({ className, label = '' }) {
  const classes = ['mini-preloader', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status" aria-label={label}>
      <span className="mini-preloader__ring" aria-hidden="true" />
    </div>
  );
}

export default MiniPreloader;
